module.exports = __webpack_public_path__ + "img/layers-copy.0f2c0220.svg";